import React from 'react';
import styled from 'styled-components';

const BorderRadius = styled.div`
  ${({size}) => size && `border-radius: ${size}px`};
`;

export default BorderRadius;

